const API_URL = process.env.VUE_APP_TRADESTARS_API_URL;
const GET_CURRENCY_RATES = `${API_URL}/token/rates`;

import EventBus, { ACTIONS } from "@/event-bus";

interface CurrencyItem {
  price: number;
  decimals: number;
  symbol: string;
  name: string;
  show: boolean;
}

interface CurrencyMap {
  [key: string]: CurrencyItem;
}

class CurrencyService {
  static get Instance(): CurrencyService {
    if (CurrencyService.bfInternal === undefined) {
      CurrencyService.bfInternal = new CurrencyService();
    }
    return CurrencyService.bfInternal;
  }

  private static bfInternal: CurrencyService;

  // TODO: fix currency rates @FRodriguez18 @chentschel
  private currencyMap: CurrencyMap = {
    TSX: {
      price: 1,
      decimals: 2,
      symbol: "",
      name: "TradeStars TSX",
      show: true,
    },
    EUR: { price: 1, decimals: 2, symbol: "€", name: "Euro", show: false },
    GBP: {
      price: 1,
      decimals: 2,
      symbol: "£",
      name: "British pound",
      show: false,
    },
    INR: {
      price: 1,
      decimals: 2,
      symbol: "₹",
      name: "Indian Rupee",
      show: true,
    },
    USD: { price: 1, decimals: 2, symbol: "$", name: "US dollar", show: true },
  };

  private cryptoTokensMap: any = {
    USDT: {},
    USDC: {},
    DAI: {},
    MATIC: {},
  };

  private tokensMap: any = {};

  public async updateRates() {
    const result = await fetch(GET_CURRENCY_RATES);

    if (!result.ok) {
      throw Error(result.statusText);
    }

    const rates = await result.json();

    this.updateTokens(rates);
  }

  public getCurrencyMap(): any {
    return this.currencyMap;
  }

  public getTokensMap(): any {
    return this.tokensMap;
  }

  public getCryptoTokensMap(): any {
    return this.cryptoTokensMap;
  }

  private updateCurrencyMap(currencyMap: any, rates: any): any[] {
    const notificationArr = [];
    for (const k of Object.keys(currencyMap)) {
      const newRate = rates.currencies[k];

      if (newRate) {
        // If rate changed add to notification arr.
        if (currencyMap[k].price !== newRate) {
          notificationArr.push(k);
        }

        currencyMap[k].price = newRate;
      } else if (k !== "USD") {
        console.debug(`No rate found for [${k}]`);
      }
    }
    return notificationArr;
  }

  public updateTokens(rates: any) {
    const notificationArr: any[] = [];

    // Only do this if there is currency info in the event data
    if (rates.currencies) {
      // 'currencies' in Object.keys(result)
      // Update currencies exchange values from feed
      // Base Currency is USD
      const currNotifs = this.updateCurrencyMap(this.currencyMap, rates);
      notificationArr.concat(currNotifs);

      // Update crypto tokens rates for deposit rates
      const cryptoNotifs = this.updateCurrencyMap(this.cryptoTokensMap, rates);
      notificationArr.concat(cryptoNotifs);
    }

    // Update token information
    for (const k of Object.keys(rates.tokens)) {
      const newInfo = rates.tokens[k];

      if (
        this.tokensMap[k] === undefined ||
        this.tokensMap[k].marketCap !== newInfo.marketCap
      ) {
        notificationArr.push(k);
      }

      const prevMap = this.tokensMap[k];
      this.tokensMap[k] = { ...this.tokensMap[k], ...rates.tokens[k] };

      // Update last24h values
      if (prevMap && notificationArr.includes(k) && k != "100000000") {
        const supplyVariation = this.tokensMap[k].supply - prevMap.supply;

        const amountVariation =
          Number(prevMap.marketCap) *
          (1 -
            (1 - Math.abs(supplyVariation) / Number(prevMap.supply)) **
              (1 / (333333 / 1000000)));

        const priceVariation = this.tokensMap[k].price - prevMap.price;
        const priceChange = +prevMap.last24h.priceChange + +priceVariation;

        const pricePercVariation =
          (priceChange * prevMap.last24h.priceChangePerc) /
          prevMap.last24h.priceChange;

        this.tokensMap[k].last24h = {
          volume: String(+prevMap.last24h.volume + amountVariation),
          priceChange: String(priceChange),
          priceChangePerc: String(pricePercVariation),
        };
      }
      //
    }

    // save last sync
    if (rates.last_synced_block) {
      localStorage.setItem("last_synced_block", rates.last_synced_block);
    }

    /// notify currency updates
    if (notificationArr.length > 0) {
      EventBus.$emit(ACTIONS.CURRENCIES_RATE_UPDATE, notificationArr);
    }
  }
}

export default CurrencyService.Instance;
